import React from 'react';
import styles from './carolbarbosapersonaltrainer_.module.scss';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import TelegramIcon from '../../icons/telegram.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5517988268918';
const WHATSAPP_MSG = 'Olá! Vim pelo cartão digital e gostaria de saber mais...';
const INSTAGRAM_URL = 'https://www.instagram.com/carolbarbosapersonaltrainer_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const TIKTOK_URL = 'https://www.tiktok.com/@anacarolinaalv06?_r=1&_t=ZS-94fE7r0gEGj';
const TELEGRAM_URL = 'https://t.me/carolbarbosapersonaltrainer';

const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;

const Carolbarbosapersonaltrainer_: React.FC = () => {
    return (
        <div className={styles.carolbarbosapersonaltrainer_}>
            <div className={styles.page}>
                <div className={styles.hero}>
                    <img
                        src={require('./src/background-links.png')}
                        alt="Gustavo Alves - Personal trainer"
                        className={styles.heroImage}
                    />
                </div>

                <div className={styles.content}>
                    <div className={styles.statsRow}>
                        <div className={styles.statBlock}>
                            <span className={styles.statValue}>+100</span>
                            <span className={styles.statLabel}>Clientes Online</span>
                        </div>
                        <div className={styles.statBlock}>
                            <span className={styles.statValue}>10</span>
                            <span className={styles.statLabel}>Anos de experiência</span>
                        </div>
                    </div>
                    <div className={styles.socialRow}>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            <InstagramIcon height="28" color="#f59036" />
                        </a>
                        <a
                            href={TIKTOK_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="TikTok"
                        >
                            <TiktokIcon height="28" color="#f59036" />
                        </a>
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Telegram"
                        >
                            <TelegramIcon height="28" color="#f59036" />
                        </a>
                        <a
                            href={whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="WhatsApp"
                        >
                            <WhatsappIcon height="28" color="#f59036" />
                        </a>
                    </div>

                    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className={styles.bannerLink}>
                        <img src={require('./src/banner-1.png')} alt="Musculação personalizada - Toque para saber mais" className={styles.banner} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Carolbarbosapersonaltrainer_;
